import { SxProps } from '@mui/system';

export const dialogPaperStyles: SxProps = {
  borderRadius: '0.5rem',
  padding: 2,
};
